import axios from 'axios'
import {androidDestroyUser, androidSaveUser} from "./AndroidApi";

const ID_USER_KEY = '247692ec-8489-11ea-bc55-0242ac130003'
const COOKIE_ID_USER_KEY = ' 307f83aa-8489-11ea-bc55-0242ac130003'

export const Admin = 'Admin'
export const OfficeAdmin = 'OfficeAdmin'
export const OfficeOwner = 'OfficeOwner'

export const getToken = () => {
  if (window.localStorage.getItem(ID_USER_KEY) !== 'undefined') {
    let user = JSON.parse(window.localStorage.getItem(ID_USER_KEY))
    if (user) {
      return user.token
    }
    let cookieUser = window.$cookies.get(COOKIE_ID_USER_KEY)
    if (cookieUser) {
      saveUser(cookieUser)
      // window.$cookies.remove(COOKIE_ID_USER_KEY)
      return cookieUser.token
    }
  }
  return null
}

export const getUser = () => {
  if (window.localStorage.getItem(ID_USER_KEY) !== 'undefined') {
    return JSON.parse(window.localStorage.getItem(ID_USER_KEY))
  }
  return null
}

export const saveUser = user => {
  window.localStorage.setItem(ID_USER_KEY, JSON.stringify(user))
  window.$cookies.set(COOKIE_ID_USER_KEY, user)
  if (getToken()) {
    androidSaveUser(JSON.stringify(user))
    axios.defaults.headers.common['Authorization'] = `Bearer ${getToken()}`
  } else {
    delete axios.defaults.headers.common['Authorization']
  }
}

export const destroyUser = () => {
  window.localStorage.removeItem(ID_USER_KEY)
  window.$cookies.remove(COOKIE_ID_USER_KEY)
  delete axios.defaults.headers.common['Authorization']
  androidDestroyUser()
}

export const isAuthenticated = () => {
  return !!getToken() && Array.isArray(getUser().roles)
}

export const hasRole = (role) => {
  let user = getUser()
  if (user && user.roles && user.roles.length > 0) {
    return user.roles.indexOf(role) > -1
  }
  return false
}

export const hasRoles = (roles) => {
  let user = getUser()
  if (user && user.roles && user.roles.length > 0) {
    const found = user.roles.some(r => roles.includes(r))
    return found
  }
  return false
}

export default { getUser, getToken, saveUser, destroyUser, isAuthenticated, hasRole }
